module.exports = __webpack_public_path__ + "img/banner-right.63f9c33d.png";